import React from 'react';
import { Card } from '../components/ui/card';
import BookingEmbed from '../components/BookingEmbed';
import SEO from '../components/SEO';

const BookAppointment = () => {
  return (
    <main className="pt-24 bg-[#FDFDFB]">
      <SEO 
        title="Book Appointment"
        description="Schedule your psychiatric evaluation with Harmony Behavioral & Psychiatric Health. Choose your preferred appointment time."
        keywords="book appointment, schedule psychiatric evaluation, mental health appointment, psychiatrist booking"
      />

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-8">
              <h1 className="text-5xl font-bold text-[#7a8a72] mb-4">Book Your Appointment</h1>
              <p className="text-xl text-[#3a3a3a]">
                Select your preferred appointment time below
              </p>
            </div>

            <Card className="p-4 md:p-8 bg-white border-[#d4cec5]">
              <BookingEmbed height="1000" />
            </Card>

            <Card className="mt-8 p-6 bg-[#f7f4f0] border-[#d4cec5]">
              <h3 className="text-xl font-semibold text-[#7a8a72] mb-3">Before Your Appointment:</h3>
              <ul className="space-y-2 text-[#3a3a3a]">
                <li className="flex items-start gap-2">
                  <span className="text-[#7a8a72]">•</span>
                  <span>Complete intake paperwork at least 48 hours before your visit</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#7a8a72]">•</span>
                  <span>Find a quiet, private space for your video visit</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#7a8a72]">•</span>
                  <span>Have your insurance card ready (if applicable)</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#7a8a72]">•</span>
                  <span>Be present 5 minutes before your appointment</span>
                </li>
              </ul>
            </Card>
          </div>
        </div>
      </section>
    </main>
  );
};

export default BookAppointment;
